{
  "iframeWaitingMessage": "Grazie per avere aspettato. Ancora qualche minuto...",
  "otherOrganizations": "Altre organizzazioni",
  "solutionIframe": "Contenuto principale",
  "unloadPromptMessage": "Vuoi procedere?"
}
